import { render } from "./HeadWithLogo.vue?vue&type=template&id=cbdd151e"
import script from "./HeadWithLogo.vue?vue&type=script&lang=js"
export * from "./HeadWithLogo.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Emertat\\Desktop\\p\\nazerhelp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__